<template>
  <div>
    <vs-tabs v-if="tabList.length > 1" v-model="tabIndex">
      <vs-tab v-for="tab of tabList" :key="tab.name" :label="tab.label" @click="onClickTab(tab)" />
    </vs-tabs>

    <vs-card>
      <div class="p-4">
        <div class="flex flex-col md:flex-row flex-wrap gap-4">
          <span style="font-weight: 700; font-size: 18px;">회원가입 승인 목록</span>
          <div class="md:ml-auto flex flex-col md:flex-row items-center gap-3">
            <div class="grid md:flex gap-4">
              <div v-if="pendingUser.registered_at" class="flex gap-2 success-color">
                <feather-icon icon="CheckCircleIcon" style="width: 16px;"/>
                <span style="font-weight: 700; font-size: 14px;">회원가입 승인</span>
              </div>
              <div v-else class="flex gap-2 alert-color align-center">
                <feather-icon icon="AlertCircleIcon" style="width: 16px;"/>
                <span style="font-weight: 700; font-size: 14px;">회원가입 거절</span>
              </div>
              <div v-if="confirm_users && confirm_users.length > 0" class="flex items-center">
                <span class="mr-2" style="font-weight: 700; font-size: 14px;">승인자: </span>
                <span style="font-weight: 400; font-size: 14px;">{{ confirm_users[0].company.com_name }} {{ confirm_users[0].rank }} {{ confirm_users[0].name }}</span>
              </div>
              <div class="flex items-center">
                <span class="mr-2" style="font-weight: 700; font-size: 14px;">승인일시: </span>
                <span style="font-weight: 400; font-size: 14px;">
                {{ pendingUser.registered_at? pendingUser.registered_at : pendingUser.rejected_at }}
              </span>
              </div>
            </div>
            <vs-button class="w-full md:w-auto" color="secondary" type="border" @click="onClickClose">닫기</vs-button>
          </div>
        </div>

        <h5 class="my-4"><i class="dot"></i> 회원구분</h5>
        <div class="grid-container mb-8">
          <radio-group
            class="col-span-4 my-2"
            flex
            :items="registerTypeList"
            :row-count="2"
            v-model="pendingUser.meta.registerType"
            readonly
          />
        </div>
        <h5 class="my-4"><i class="dot"></i> 작업자 정보</h5>
        <div class="grid-container">
          <input-form class="grid-item" label="사업장명">
            <ml-input
              class="w-full"
              :value="pendingUser.meta.field.field_name? pendingUser.meta.field.field_name : ''"
              readonly
            />
          </input-form>
          <input-form class="grid-item" label="동국제강 담당부서">
            <ml-input
              class="w-full"
              :value="pendingUser.meta.담당부서 ? pendingUser.meta.담당부서 : ''"
              readonly
            />
          </input-form>

          <!-- 일용직 회원의 경우 업체검색 폼이 나타나지 않도록 함 -->
          <input-form v-if="pendingUser.meta.registerType !== 일용직.value" class="grid-item" label="업체명(사업자등록번호)">
            <div class="align-center" style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.675rem;">
              <ml-input class="w-full" :value="pendingUser.meta.업체.com_name? pendingUser.meta.업체.com_name : ''" readonly />
              <ml-input class="w-full" :value="pendingUser.meta.업체.com_number? pendingUser.meta.업체.com_number : ''" readonly />
            </div>
          </input-form>
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="아이디">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="아이디 입력"
                :value="pendingUser.username? pendingUser.username : ''"
                readonly
              />
            </label>
          </input-form>
          <input-form class="grid-item" label="비밀번호">
            <ml-input class="w-full" type="password" placeholder="********" readonly />
          </input-form>

          <input-form class="grid-item gap-2" label="내국인/외국인">
            <radio-group
              class="col-span-4 my-2"
              flex
              :items="[{label: '내국인', value: false}, {label: '외국인', value: true}]"
              :row-count="2"
              v-model="pendingUser.isForeigner"
              readonly
            />
          </input-form>

        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="이름">
            <ml-input class="w-full" :value="pendingUser.name? pendingUser.name : ''" readonly />
          </input-form>
          <input-form class="grid-item" :label="pendingUser.isForeigner? '외국인등록번호(앞 7자리 한정)':'주민등록번호(앞 7자리 한정)'">
            <ml-input class="w-full" :value="formatRRN" readonly />
          </input-form>

          <input-form class="grid-item" label="휴대폰번호">
            <div class="flex gap-2">
              <ml-input class="w-full" :value="pendingUser.phone1? pendingUser.phone1 : ''" :max="3" readonly />
              <span style="align-content: center;">-</span>
              <ml-input class="w-full" :value="pendingUser.phone2? pendingUser.phone2 : ''" :max="4" readonly />
              <span style="align-content: center;">-</span>
              <ml-input class="w-full" :value="pendingUser.phone3? pendingUser.phone3 : ''" :max="4" readonly />
            </div>
          </input-form>
          <input-form class="grid-item" label="이메일">
            <ml-input class="w-full" :value="pendingUser.email? pendingUser.email: ''" readonly />
          </input-form>

<!--          <input-form class="grid-item" label="주소">-->
<!--            <ml-input class="w-full" :value="pendingUser.meta.address.home_address_1? pendingUser.meta.address.home_address_1: ''" readonly />-->
<!--            <ml-input class="w-full mt-2" :value="pendingUser.meta.address.home_address_2? pendingUser.meta.address.home_address_2: ''" readonly />-->
<!--          </input-form>-->
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="직책">
            <ml-input class="w-full" :value="pendingUser.meta.직책? pendingUser.meta.직책 : ''" readonly />
          </input-form>
          <input-form class="grid-item" label="직종">
            <ml-input class="w-full" :value="pendingUser.meta.직종? pendingUser.meta.직종 : ''" readonly />
          </input-form>
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="건설업기초안전교육">
            <file-uploader-none-token
              class="w-full"
              v-model="pendingUser.meta.건설업기초안전교육" readonly/>
          </input-form>
          <input-form class="grid-item" label="교육 이수번호">
            <ml-input class="w-full" :value="pendingUser.meta.교육이수번호? pendingUser.meta.교육이수번호 : ''" readonly />
          </input-form>

          <input-form class="grid-item" label="서명 등록">
            <div class="h-full" style="border: solid 1px #cdcdcd;  border-radius: 6px; background-color: #F4F4F4; width: 367px; min-height: 120px">
              <img :src="pendingUser.meta.서명" alt="" height="120" class="my-1"/>
            </div>

            <div class="mt-2">
              <span style="color: #4839EB; font-weight: 400;">
                ※ 본인 고유의 필체로 자신의 이름을 제 3자가 알아볼 수 있도록 정자로 서명등록 부탁드립니다.<br/>
                (이름 확인이 안될 시 반려될 수 있습니다.)
              </span>
              <img :src="require('@/assets/images/pages/register/example_sign_col.svg')" alt="example_sign" class="mt-2" style="width: 100%;"/>
            </div>
          </input-form>
          <input-form class="grid-item" label="신분증 사진">
            <div class="h-full" style="width: 367px; min-height: 120px">
              <img :src="pendingUser.meta.enc.신분증사진 && pendingUser.meta.enc.신분증사진 !== ''?
                           pendingUser.meta.enc.신분증사진 : require(`@/assets/images/checker.svg`)" alt="" height="120" class="my-1"/>
            </div>

            <div class="mt-2">
              <span style="color: #4839EB; font-weight: 400;">
                ※ 주민등록번호 뒷자리는 가려서 촬영해주세요.
              </span>
              <img :src="require('@/assets/images/pages/register/example_identification_col.svg')" alt="example_identification" class="mt-2" style="width: 100%;"/>
            </div>
          </input-form>
        </div>

        <h5 class="my-8 flex gap-2"><print-checkbox :value="pendingUser.meta.장비운전자"/> 장비운전자</h5>
        <div class="grid-container mt-4">
          <div class="grid-item">
            <span>건설기계 조종사 면허</span>
            <ml-input class="my-1 w-full" :value="pendingUser.meta.건설기계조종사면허번호? pendingUser.meta.건설기계조종사면허번호 : ''" readonly />
          </div>
          <div class="grid-item grid">
            <span>면허증 사진</span>
            <div class="h-full" style="width: 367px; min-height: 120px">
              <img :src="pendingUser.meta.enc.건설기계조종사면허증사진 && pendingUser.meta.enc.건설기계조종사면허증사진 !== '' ?
                           pendingUser.meta.enc.건설기계조종사면허증사진 : require(`@/assets/images/checker.svg`)" alt="" height="120" class="my-1"/>
            </div>

            <div>
              <span style="color: #ff0000; font-weight: 400;">
                ※ 주민등록번호 뒷자리는 가려서 촬영해주세요.
              </span>
            </div>
          </div>
        </div>

        <div v-if="pendingUser.rejected_at" class="grid-container mt-4">
          <input-form class="grid-item" label="거절 사유">
            <ml-textarea class="w-full" :value="(confirm_users && confirm_users.length>0) ? confirm_users[0].pivot.memo : ''" readonly />
          </input-form>
        </div>
      </div>

    </vs-card>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import HttpRequest from "@/util/HttpRequest";
import FileUploader from "@/components/FileUploader.vue";
import SignField from "@/components/SignField.vue";
import FileUploaderNoneToken from "@/components/FileUploaderNoneToken.vue";
import AddressField from "@/components/AddressField.vue";
import InputForm from "@/views/pages/register/InputForm.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import {getRegisterTypeInfo, registerTypeList} from "@/views/pages/register/RegisterTypeInfo.js";
export default {
  components: {
    PrintCheckbox,
    RadioGroup,
    InputForm,
    AddressField,
    FileUploaderNoneToken,
    SignField,
    FileUploader,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  computed:{
    tabList() {
      const list = [
        { code: 0, name: "page-standing-account-list", label: "회원가입 대기 목록", },
        { code: 1, name: "page-confirm-account-list", label: "회원가입 승인 목록", }
      ];
      return list;
    },

    getId () {
      return this.$route.params.id
    },

    formatRRN: {
      get() {
        const rrn = this.pendingUser.rrn;
        if (!rrn || rrn.length !== 7 || isNaN(rrn)) {
          return '';
        }

        const datePart = rrn.slice(0, 6);
        const lastDigit = rrn[6];

        return `${datePart}-${lastDigit}******`;
      },
      set(newValue) {
        const cleanValue = newValue.replace(/[^0-9]/g, '').slice(0, 7);
        this.pendingUser.rrn = cleanValue;
      },
    },

    check업체() {
      if (!this.pendingUser.meta.업체 || this.pendingUser.meta.업체 === "") {
        this.error.업체 = "업체가 지정되지 않았습니다."
        return true;
      }

      this.error.업체 = ""
      return false
    }
  },
  data() {
    return {
      tabIndex: 1,
      registerTypeList: registerTypeList,
      일용직: getRegisterTypeInfo('일용직'),

      pendingUser: {
        id: 0,
        username: "",
        name: "",
        name_masked: "",
        rrn: "",
        phone: "",
        phone1: "",
        phone2: "",
        phone3: "",
        phone_masked: "",
        email: "",
        email_masked: "",
        isForeigner: false,
        registered_at: "",
        rejected_at: "",
        created_at: "",
        updated_at: "",
        meta: {
          address: {
            home_zip: "",
            home_address_1: "",
            home_address_2: "",
          },
          직책: "",
          직종: "",
          field: "",
          건설업기초안전교육: "",
          교육이수번호: "",
          담당부서: "",
          업체: {
            com_name: "",
            com_number: "",
          },
          장비운전자: false,
          서명: "",
          건설기계조종사면허번호: "",
          enc: {
            신분증사진: "",
            건설기계조종사면허증사진: "",
          },
          registerType: 0,
        },
      },
      confirm_users: [],
    };
  },
  async created() {
    this.initBreadcrumb()
    await this.loadPendingUser(this.getId)
  },
  // input-icon-validate 클래스를 가진 엘리먼트에 대해 MutationObserver를 이용하여 자식 엘리먼트가 추가될 때마다 display: none 처리
  mounted() {
    this.$nextTick(() => {
      const iconElements = this.$el.querySelectorAll('.input-icon-validate');
      iconElements.forEach(iconElement => {
        iconElement.style.display = 'none';
      });

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              if (node.classList && node.classList.contains('input-icon-validate')) {
                node.style.display = 'none';
              }
            });
          }
        });
      });

      observer.observe(this.$el, { childList: true, subtree: true });
    });
  },
  methods: {
    initBreadcrumb () {
      this.$store.commit('menu/UPDATE_PAGE_LIST', [{title: 'Home'}, {title: '작업자 관리'}, {title: '회원가입 신청 현황', active: true}])
    },
    onClickTab(tab) {
      this.tabIndex = tab.code;
      this.$router.push({ name: tab.name });
    },
    onClickClose() {
      // 쿼리 파라미터가 있으면 해당 쿼리와 함께 리스트 페이지로 이동
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.push({
          name: 'page-confirm-account-list',
          query: this.$route.query
        });
      } else {
        // 쿼리 파라미터가 없으면 이전 페이지로 돌아가기
        this.$router.go(-1);
      }
    },

    async loadPendingUser(userId) {
      try {
        const response = await HttpRequest.get(`/api/v1/user/pending/${userId}`);

        if (response) {

          this.pendingUser.id = response.id;
          this.pendingUser.username = response.username;
          this.pendingUser.name = response.name? response.name : "";
          this.pendingUser.name_masked = response.name_masked? response.name_masked : "";
          this.pendingUser.rrn = response.rrn? response.rrn : "";
          this.pendingUser.phone = response.phone? response.phone : "";

          // Split phone number into parts
          if (response.phone && response.phone.length === 11) {
            this.pendingUser.phone1 = response.phone.substring(0, 3);
            this.pendingUser.phone2 = response.phone.substring(3, 7);
            this.pendingUser.phone3 = response.phone.substring(7, 11);
          }

          this.pendingUser.phone_masked = response.phone_masked? response.phone_masked : "";
          this.pendingUser.email = response.email? response.email: "";
          this.pendingUser.email_masked = response.email_masked? response.email_masked : "";
          this.pendingUser.isForeigner = response.is_foreigner === undefined? false : response.is_foreigner;
          this.pendingUser.registered_at = response.registered_at;
          this.pendingUser.rejected_at = response.rejected_at;
          this.pendingUser.created_at = response.created_at;
          this.pendingUser.updated_at = response.updated_at;
          this.pendingUser.meta = response.meta;

          this.fixMissingMetaData()

          if (response.confirm_users && response.confirm_users.length > 0) {
            this.confirm_users = response.confirm_users;
          }


          console.log("this.pendingUser", this.pendingUser);
        } else {
          console.error("Response or response.data is undefined");
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
    },

    fixMissingMetaData() {
      if (!this.pendingUser.meta) {
        this.pendingUser.meta = {
          address: {
            home_zip: "",
            home_address_1: "",
            home_address_2: "",
          },
          직책: "",
          직종: "",
          field: "",
          건설업기초안전교육: "",
          교육이수번호: "",
          담당부서: "",
          업체: {
            com_name: "",
            com_number: "",
          },
          장비운전자: false,
          서명: "",
          건설기계조종사면허번호: "",
          enc: {
            신분증사진: "",
            건설기계조종사면허증사진: "",
          },
          registerType: 0,
        };
        return
      }

      // Set default values for missing fields
      if (this.pendingUser.meta.담당부서 === undefined) {
        this.pendingUser.meta.담당부서 = "";
      }
      if (this.pendingUser.meta.업체 === undefined) {
        this.pendingUser.meta.업체 = "";
      }
      if (this.pendingUser.meta.직책 === undefined) {
        this.pendingUser.meta.직책 = "";
      }
      if (this.pendingUser.meta.직종 === undefined) {
        this.pendingUser.meta.직종 = "";
      }
      if (this.pendingUser.meta.건설업기초안전교육 === undefined) {
        this.pendingUser.meta.건설업기초안전교육 = "";
      }
      if (this.pendingUser.meta.교육이수번호 === undefined) {
        this.pendingUser.meta.교육이수번호 = "";
      }
      if (this.pendingUser.meta.서명 === undefined) {
        this.pendingUser.meta.서명 = "";
      }
      if (this.pendingUser.meta.enc.신분증사진 === undefined) {
        this.pendingUser.meta.enc.신분증사진 = "";
      }
      if (this.pendingUser.meta.건설기계조종사면허번호 === undefined) {
        this.pendingUser.meta.건설기계조종사면허번호 = "";
      }
      if (this.pendingUser.meta.enc.건설기계조종사면허증사진 === undefined) {
        this.pendingUser.meta.enc.건설기계조종사면허증사진 = "";
      }
      if (this.pendingUser.meta.장비운전자 === undefined) {
        this.pendingUser.meta.장비운전자 = false;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    background-color: #f5f5f5;
    font-weight: 700;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-body {
    background-color: #ffffff;
    & > div { border-bottom: 1px solid #e0e0e0; }
    & > div:hover { background-color: #f5f5f5; color: #000; font-weight: bold }
    & > div.active { background-color: #7E72F299; color: #fff }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(10, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }



  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}


.align-center {
  align-items: center;
}
.success-color {
  color: #28C76F;
}
.alert-color {
  color: #EA5455;
}
.input-button {
  height: 37.5px
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}

.grid-item {
  align-self: start;
  grid-column: span 2;
}

@media (min-width: 768px) {
  .grid-item {
    align-self: start;
    grid-column: span 1;
  }
}
</style>
